module.exports = __webpack_public_path__ + "static/93-1fc5690b6599eae6ca56baa3fa579c71.png";